// extracted by mini-css-extract-plugin
module.exports = {"root":"SaasExtraOptions_root__fHblJ","head":"SaasExtraOptions_head__EmDXl","table":"SaasExtraOptions_table__3RuEC"};